<script lang="ts">
    import {Component, Watch} from 'vue-facing-decorator'
    import {OrderSelectionMixin} from '@/components/account/mixins/OrderSelectionMixin.vue'

    @Component
    export class FillServiceBookingDataMixin extends OrderSelectionMixin {
        bookingFieldsLoading = false
        formRefs = []
        allNestedFormsValid = false

        @Watch('modal')
        toggleOrderSelected(modal) {
            this.formRefs = []
            if (modal) {
                this.setSelectedOrderAndCompany()
            } else {
                this.resetSelectedOrderAndCompany()
            }
        }

        @Watch('tourists', {deep: true})
        async onTouristsChange() {
            await this.$nextTick()
            this.allNestedFormsValid = await this.validateNestedForms(this)
        }

        async loadTouristBookingFields() {
            this.bookingFieldsLoading = true
            try {
                await runtimeStore.loadTouristBookingFields({processId: this.service.processId})

                // eslint-disable-next-line no-empty
            } catch (e) {
            } finally {
                this.bookingFieldsLoading = false
            }
        }

        async loadProductBookingFields() {
            this.bookingFieldsLoading = true
            try {
                await runtimeStore.loadProductBookingFields({processId: this.service.processId})

                // eslint-disable-next-line no-empty
            } catch (e) {
            } finally {
                this.bookingFieldsLoading = false
            }
        }

        setTourists(orderTravelers) {
            const travelers = orderTravelers || this.service.travelers
            const tourists = travelers.map(tourist => runtimeStore.touristFromTraveler(tourist))
            const persistTourists = persistentStore.tourists

            tourists.forEach(tourist => {
                const persistTourist = persistTourists.find(
                    pt => pt.firstName === tourist.firstName && pt.lastName === tourist.lastName
                )

                if (persistTourist) {
                    for (const prop in tourist) {
                        if (prop === 'passport ') {
                            for (const passportProp in tourist.passport) {
                                if (!tourist.passport[passportProp] && !!persistTourist.passport[prop]) {
                                    tourist.passport[passportProp] = persistTourist.passport[prop]
                                }
                            }
                        } else if (!tourist[prop] && !!persistTourist[prop]) {
                            tourist[prop] = persistTourist[prop]
                        }
                    }
                }
            })

            persistentStore.SET_TOURISTS(tourists)
        }

        async validateNestedForms(comp) {
            let valid = true
            if (comp?.$refs?.form?.validate) {
                valid = (await comp.$refs.form.validate()).valid && valid
            }
            if (comp?.formRefs?.length) {
                for (const childComp of comp.formRefs) {
                    valid = (await this.validateNestedForms(childComp)) && valid
                }
            }
            return valid
        }

        addFormRef(component) {
            if (!this.formRefs.find(ref => ref?._.uid === component?._.uid)) this.formRefs.push(component)
        }
    }

    export default FillServiceBookingDataMixin
</script>
